import { useState } from 'react';

const Footer = () => {
	const margin: string = '14px';

	const style: React.CSSProperties = {
		fontSize: '0.8em',
		color: '#666',
		marginTop: '-3px',
	};

	const [extLogoVisible, setExtLogoVisible] = useState<boolean>(true);
	const logoPath = '/img/logo/logo_sm.png';
	const extLogoPath = '/img/logoExt/external_logo_login.png';

	const setExtLogoInvisible = (): void => {
		setExtLogoVisible(false);
	};

	return (
		<div id="footer-container">
			<div className="container">
				<hr style={{ margin: '0px' }} />
			</div>
			<div
				className="container d-flex align-items-center"
				style={{
					gap: margin,
					paddingTop: margin,
					paddingBottom: margin,
				}}
			>
				<img
					src={logoPath}
					alt=""
					height="40"
					className="d-inline-block align-text-middle"
				/>
				<div style={style}>Artificial Intelligence Recipes</div>
				{extLogoVisible && (
					<>
						<div style={style}>│</div>
						<img
							src={extLogoPath}
							onError={setExtLogoInvisible}
							height="40"
							className="d-inline-block align-text-middle"
						/>
					</>
				)}
				<div style={style}>│</div>
				<div style={style}>Copyright: PrePress &amp; Multimedia AG</div>
			</div>
		</div>
	);
};

export default Footer;
